// src/store/rootReducer.js
import { combineReducers } from 'redux'
import userReducer from './userSlice'
import sidebarReducer from './sidebar/sidebarReducer'
import conversationsReducer from './conversations/conversationsReducer'
import messagesReducer from './messages/messagesReducer'
import notificationsReducer from './notifications/notificationsReducer'
import languageReducer from './languageSlice'

// Nouveau reducer pour la messagerie flottante
import floatingMessagingReducer from './messaging/messagingSlice'

const rootReducer = combineReducers({
  user: userReducer,
  sidebar: sidebarReducer,
  conversations: conversationsReducer,
  messages: messagesReducer,
  notifications: notificationsReducer,
  language: languageReducer, // i18n : current / supported / default (S1)
  floatingMessaging: floatingMessagingReducer, // Ajout du nouveau système de messagerie flottante
})

export default rootReducer
